var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h4.02v1H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.979 20.452a.503.503 0 0 1-.474-.338L8.979 1 2.474 20.113a.5.5 0 1 1-.948-.322L8.034.678A1.003 1.003 0 0 1 9.42.103c.24.118.42.32.506.574l6.527 19.113a.501.501 0 0 1-.474.662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.59 13.452H4.383a.5.5 0 0 1 0-1h9.207a.5.5 0 0 1 0 1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.452)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.52 1H.5a.5.5 0 0 1 0-1h3.02a.5.5 0 0 1 0 1",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 20.452h-3.021a.5.5 0 1 1 0-1H17.5a.5.5 0 0 1 0 1M22.5 20.452a.503.503 0 0 1-.474-.338l-4.123-12.08-1.886 5.544a.5.5 0 0 1-.948-.322l1.888-5.543a.998.998 0 0 1 1.387-.575.996.996 0 0 1 .506.573l4.124 12.079a.501.501 0 0 1-.474.662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.794 15.452H16.92a.5.5 0 0 1 0-1h3.874a.5.5 0 0 1 0 1M23.5 20.452h-1.984a.5.5 0 1 1 0-1H23.5a.5.5 0 0 1 0 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.9c2c3cb72fd683b9a4ffad93180a1c0e.svg";
export { ForwardRef as ReactComponent };